import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

const CATEGORIES = [
    "All",
    "Attractions",
    "Beer / Drinks",
    "Accommodations",
    "Coffee Shops",
    "Dining",
    "Retail",
    "Transportation",
    "Golf / Mini",
    "Tours / Excursions",
    "Spa / Health",
    "Museums",
    "Misc",
];

const TrendingOne = () => {
    const navigate = useNavigate();
    const [activeCategory, setActiveCategory] = useState("All");
    const [vendors, setVendors] = useState([]);
    const [loading, setLoading] = useState(true);

    const handleVendorNavigateClick = (id) => {
        navigate(`/vendor/${id}`);
    };

    useEffect(() => {
        const fetchVendors = async () => {
            setLoading(true);
            try {
                const url = `${process.env.REACT_APP_API_URL}/api/vendors/trending-by-category?category=${encodeURIComponent(activeCategory)}`;
                const res = await fetch(url);
                const data = await res.json();
                setVendors(Array.isArray(data) ? data : []);
            } catch (err) {
                console.error(err);
                setVendors([]);
            } finally {
                setLoading(false);
            }
        };
        fetchVendors();
    }, [activeCategory]);

    return (
        <section className="trending-productss pt-80">
            <style>{`
                .trending1-card { box-shadow: 0 2px 16px rgba(0,0,0,0.05); border-color: #edf2f7 !important; }
                .trending1-title { font-size: 20px; font-weight: 700; color: #0f172a; display: flex; align-items: center; gap: 10px; margin: 0 0 16px; }
                .trending1-accent { display: inline-block; width: 4px; height: 20px; background: linear-gradient(180deg, #4da8e8, #2575fc); border-radius: 2px; flex-shrink: 0; }
                .trending-products-box { box-shadow: 0 2px 12px rgba(0,0,0,0.07); }
                .trending-products-box__content h6 { font-size: 16px; font-weight: 700; letter-spacing: -0.1px; }
            `}</style>
            <div className="container container-lg">
                <div className="border border-gray-100 p-24 rounded-16 trending1-card">
                    <div className="section-heading mb-24">
                        <h5 className="trending1-title">
                            <span className="trending1-accent" />
                            Trending Coupon Vendors
                        </h5>
                        <div style={{ overflowX: "auto", scrollbarWidth: "none", msOverflowStyle: "none" }}>
                            <ul
                                className="nav common-tab style-two nav-pills flex-nowrap"
                                id="pills-tab"
                                role="tablist"
                                style={{ minWidth: "max-content" }}
                            >
                                {CATEGORIES.map((cat) => (
                                    <li key={cat} className="nav-item" role="presentation">
                                        <button
                                            className={`nav-link${activeCategory === cat ? " active" : ""}`}
                                            type="button"
                                            role="tab"
                                            onClick={() => setActiveCategory(cat)}
                                        >
                                            {cat}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    <div className="trending-products-box rounded-16 overflow-hidden flex-between position-relative mb-24">
                        <div className="d-md-block d-none ps-xxl-5 ps-md-4">
                            {/* <img src="assets/images/thumbs/trending-products-img1.png" alt="" /> */}
                        </div>
                        <div className="trending-products-box__content px-4 d-block w-100 text-center py-32">
                            <h6 className="mb-0 trending-products-box__title" style={{ fontSize: 22 }}>
                                Top #6 Most Frequented
                            </h6>
                            <h6 className="mb-0 trending-products-box__title" style={{ fontSize: 22 }}>
                                Fun Card Coupon Vendors
                            </h6>
                        </div>
                        <div className="d-md-block d-none pe-xxl-5 me-xxl-5 pe-md-4">
                            {/* <img src="assets/images/thumbs/trending-products-img2.png" alt="" /> */}
                        </div>
                    </div>

                    {activeCategory !== "All" && (
                        <p className="mb-16 fw-semibold" style={{ fontSize: 14, color: "#0f172a" }}>
                            Filtering Vendors With <span style={{ color: "#2575fc" }}>{activeCategory}</span> Coupons
                        </p>
                    )}

                    <div className="row g-12">
                        {loading ? (
                            <div className="col-12 text-center py-32 text-gray-500">
                                Loading vendors...
                            </div>
                        ) : vendors.length > 0 ? (
                            vendors.map((vendor, key) => (
                                <div key={key} className="col-xxl-2 col-xl-3 col-lg-4 col-sm-6">
                                    <div className="product-card h-100 p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 d-flex flex-column">
                                        <div
                                            onClick={() => handleVendorNavigateClick(vendor.id)}
                                            className="product-card__thumb flex-center rounded-8 bg-gray-50 position-relative w-100"
                                            style={{ cursor: "pointer", overflow: 'hidden' }}
                                        >
                                            <span className="product-card__badge bg-tertiary-600 px-8 py-4 text-sm text-white position-absolute inset-inline-start-0 inset-block-start-0">
                                                Best Seller
                                            </span>
                                            {vendor.image ? (
                                                <img
                                                    src={vendor.image}
                                                    alt=""
                                                    style={{ width: '100%', height: '100%', maxWidth: 'none', maxHeight: 'none', objectFit: 'cover', position: 'absolute', inset: 0 }}
                                                />
                                            ) : (
                                                <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f3f4f6' }}>
                                                    <i className="bi bi-shop" style={{ fontSize: '2.5rem', color: '#9ca3af' }} />
                                                </div>
                                            )}
                                        </div>
                                        {vendor.business_name && (
                                            <div className="flex-align gap-4 mt-8">
                                                <span className="text-tertiary-600 text-sm d-flex"><i className="ph-fill ph-storefront" /></span>
                                                <span className="text-xs fw-medium text-gray-500" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block', minWidth: 0 }}>{vendor.business_name}</span>
                                            </div>
                                        )}
                                        <div
                                            className="product-card__content w-100 mt-16 d-flex flex-column flex-grow-1"
                                            style={{ justifyContent: "space-between" }}
                                        >
                                            <div className="w-100">
                                                <h6 className="title text-lg fw-semibold mt-8 mb-16 w-100">
                                                    <div
                                                        onClick={() => handleVendorNavigateClick(vendor.id)}
                                                        className="link d-block"
                                                        tabIndex={0}
                                                        style={{ cursor: "pointer", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                                    >
                                                        {vendor.vendor_name}
                                                    </div>
                                                </h6>
                                                <div className="flex-align gap-6 w-100 mb-12">
                                                    <div className="flex-align gap-8">
                                                        {[1, 2, 3, 4, 5].map((s) => (
                                                            <span key={s} className={`text-15 fw-medium d-flex ${s <= Math.round(vendor.avg_rating || 0) ? 'text-warning-600' : 'text-gray-300'}`}>
                                                                <i className="ph-fill ph-star" />
                                                            </span>
                                                        ))}
                                                    </div>
                                                    <span className="text-xs fw-medium text-gray-500">{vendor.avg_rating ?? "—"}</span>
                                                    <span className="text-xs fw-medium text-gray-500">({vendor.rating_count ?? 0})</span>
                                                </div>
                                                <p className="text-gray-500 text-sm mb-0 w-100" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                    {vendor.vendor_description}
                                                </p>
                                            </div>
                                            <div className="w-100 mt-16">
                                                <span className="py-2 px-8 text-xs rounded-pill text-main-two-600 bg-main-two-50 d-block w-100 text-center mb-16">
                                                    Highly Rated
                                                </span>
                                                <Link
                                                    to={`/vendor/${vendor.id}`}
                                                    className="product-card__cart w-100 btn bg-main-800 text-white hover-bg-main-700 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium"
                                                >
                                                    See Vendor <i className="ph ph-arrow-right" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="col-12 text-center py-32 text-gray-500">
                                No vendors found{activeCategory !== "All" ? ` in "${activeCategory}"` : ""}.
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TrendingOne;
